module.exports = __webpack_public_path__ + "img/iboundC.94ad3c63.jpg";